<template>
  <div class="container">
    <Header />
    <main role="main">
      <router-view />
      <Footer />
    </main>
  </div>
</template>

<script>
import Header from "./components/Header.vue";
import Footer from "./components/Footer.vue";

export default {
  name: "Home",
  components: {
    Header,
    Footer,
  },
};
</script>
<style>
body {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
  font-family: Menlo, Monaco, Lucida Console, Liberation Mono, DejaVu Sans Mono,
    Bitstream Vera Sans Mono, Courier New, monospace, serif;
  font-weight: 100;
  color: #6cff91;
  /*background-color: #303841;*/
  background: url("/images/pattern.png");
  background-repeat: repeat;
}
.container {
  padding-right: 0px;
  padding-left: 0px;
  margin-right: auto;
  margin-left: auto;
  width: 900px;
}
@media (min-width: 48em) {
  .container {
    max-width: 100rem; /* width of content */
  }
}
.indent {
  padding-left: 8px;
  margin-left: 8px;
  border-left: 2px solid #888;
  xcolor: #888;
}
.post {
  padding-top: 0;
  padding-bottom: 0;
  padding-left: 0;
  padding-right: 0;
  margin: 0 0 0 0;
}

.post {
  margin-bottom: 8px;
  color: inherit;
  text-align: left;
  padding: 0 0 0 0;
  margin: 0 0 0 0;
  line-height: 1.5em;
}
.post h1,
h2,
h3 .post .h1 .h2 .h3 {
  color: #b6b51a;
}
.post .post-title {
  margin-bottom: 10px;
  font-size: 36px;
  color: #dadada;
  line-height: 1em;
}
.post .post-title a:link {
  color: inherit;
  text-decoration: none;
}
.post .post-title a:hover {
  color: inherit;
  text-decoration: underline;
}
.post .post-title a:visited {
  color: inherit;
  text-decoration: none;
}
.post .post-title a:active {
  color: inherit;
  text-decoration: none;
}

.post > p > a:link {
  color: #337ab7;
  text-decoration: none;
}
.post > p > a:hover {
  color: #337ab7;
  text-decoration: underline;
}
.post > p > a:visited {
  color: #337ab7;
  text-decoration: none;
}
.post > p > a:active {
  color: #337ab7;
  text-decoration: none;
}

.post p {
  margin-bottom: 20px;
  font-size: 14px;
}

.post code {
  background-color: #222;
  padding: 4px;
  padding-right: 5px;
  padding-left: 5px;
  color: #0a7;
}

.post pre {
  font-size: 14px;
  margin: 0;
  margin-bottom: 20px;
  padding: 5px;
  background-color: #222;
  color: #0a7;
  width: 100%;
}

.post pre > code {
  margin: 0;
  padding: 0;
}

a:link {
  color: #337ab7;
  text-decoration: none;
}
a:hover {
  color: #337ab7;
  text-decoration: underline;
}
a:visited {
  color: #337ab7;
  text-decoration: none;
}
a:active {
  color: #337ab7;
  text-decoration: none;
}

h1,
h2,
h3,
h4,
h5 {
  font-weight: 100;
}

.post img {
  image-orientation: from-image;
  max-width: 100%;
  height: auto;
  vertical-align: middle;
  border: 0px;
}
.post .date {
  color: #888;
  padding-top: 8px;
  padding-bottom: 16px;
  font-size: 12px;
}
</style>
